var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import BaseRememberLoginRoute, { RememberLoginOptions, } from "../../features/auth/routes/remember-login";
import { DEFAULT_MANUAL_FORMS_BUTTON_TEXT } from "../../lib/constants";
import { PHASE } from "../../routeConfig";
import { completedPage } from "../../lib/Avo";
import { enteredUnlinkedApplication } from "../../features/unlinked-application/unlinkedApplicationSlice";
import useAppDispatch from "../../hooks/useAppDispatch";
import useAppSelector from "../../hooks/useAppSelector";
import useCanShowMidFunnelAds from "../../features/configuration/useCanShowMidFunnelAds";
import useForgotPasswordRoute from "../../hooks/useForgotPasswordRoute";
import useUnlinkedApplicationEntryRoute from "../../features/unlinked-application/useUnlinkedApplicationEntryRoute";
export default function RememberLoginRoute() {
    var selectedIssuer = useAppSelector(function (state) { return state.applicant.currentIssuer.auto; });
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics; }).commonAnalyticsProperties;
    var _a = useAppSelector(function (state) { return state.configuration; }), enableFormExperience = _a.enableFormExperience, manualFormsButtonText = _a.manualFormsButtonText;
    var canShowMidFunnelAds = useCanShowMidFunnelAds();
    var forgotPasswordRoute = useForgotPasswordRoute();
    var dispatch = useAppDispatch();
    var unlinkedEntryRoute = useUnlinkedApplicationEntryRoute();
    var fillOutFormsManuallyText = manualFormsButtonText || DEFAULT_MANUAL_FORMS_BUTTON_TEXT;
    var onSelectRememberLogin = function (option) {
        if (option !== RememberLoginOptions.YES) {
            dispatch(enteredUnlinkedApplication("manual-forms"));
        }
        completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: option, optionSelected: option }));
    };
    var options = [
        {
            label: "Yes/Maybe - Let's try it",
            nextPhase: PHASE.DISCLAIMER,
            onSelect: function () { return onSelectRememberLogin(RememberLoginOptions.YES); },
        },
        canShowMidFunnelAds && {
            label: "No - ".concat(fillOutFormsManuallyText),
            nextPhase: enableFormExperience
                ? unlinkedEntryRoute
                : PHASE.MID_FUNNEL_ADS_UNSUPPORTED_ISSUER,
            onSelect: function () { return onSelectRememberLogin(DEFAULT_MANUAL_FORMS_BUTTON_TEXT); },
        },
        !canShowMidFunnelAds && {
            label: RememberLoginOptions.NO_FORGOT_LOGIN,
            nextPhase: forgotPasswordRoute,
            onSelect: function () {
                return onSelectRememberLogin(RememberLoginOptions.NO_FORGOT_LOGIN);
            },
        },
    ].filter(Boolean);
    if (!(selectedIssuer === null || selectedIssuer === void 0 ? void 0 : selectedIssuer.id)) {
        return null;
    }
    return React.createElement(BaseRememberLoginRoute, { options: options, issuer: selectedIssuer });
}
